var render = function render(){var _vm=this,_c=_vm._self._c;return _c('oiliness-location-template',{attrs:{"gender":_vm.gender,"greasy-skin-locations":_vm.greasySkinLocations,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }